import React from 'react';
import { useFormContext } from 'react-hook-form';

import KogCheckBoxControlled from '@/main/components/shared/checkbox/checkBoxControlled';
import KogAutoCompleteControlled from '@/main/components/shared/inputAutoComplete/autoCompleteControlled';
import KOGImage from '@/main/components/shared/kogImage/kogImage';
import useKogControlElementId from '@/main/hooks/useKogControlElementId';
import QuoteProcurementPartInfo from '@/main/components/shared/quoteProcurementPartInfo/quoteProcurementPartInfo';

import { RequoteProcurementItemResponse } from '@/main/models/response';
import { Controls } from '@/main/services/constants/constantsControl';
import { getTranslateByKey, isNullUndefined } from '@/main/services/utils';
import { usePartTypeReducer } from '@/main/store/partType';

import { IItemFormRequoteOrdered, IRequoteOrderedForm } from '../modalRequoteOrderedPart';
import * as S from './styles';

interface IRowItemRequoteOrderedProps {
  part: RequoteProcurementItemResponse;
  index: number;
  indexSupplier: number;
}
function RowItemRequoteOrdered({
  part,
  index,
  indexSupplier
}: IRowItemRequoteOrderedProps) {
  const CONTROL_SHOW_PART_TYPE = useKogControlElementId(Controls.IdSearchProcurementRequotePartType)
  const { partType: partTypeReducer } = usePartTypeReducer();
  const {
    control,
    getValues,
    setValue
  } = useFormContext<IRequoteOrderedForm>();

  const isDisabledPartTypeDrop = isNullUndefined(partTypeReducer.data) || partTypeReducer.data.length === 1;

  type keyFieldsItems = keyof IItemFormRequoteOrdered;
  const nameField = (name: keyFieldsItems) => `suppliers.${indexSupplier}.items.${index}.${name}`;

  return (
    <S.Container>
      <KOGImage
        src={part.image1}
        alt=''
      />

      <S.AreaTitlePart>
        <QuoteProcurementPartInfo
          data={part.quoteProcurementPartInfo}
          renderType="column"
          isTooltip
        />
        {CONTROL_SHOW_PART_TYPE && (
          <KogAutoCompleteControlled
            nameCustom={nameField("partType")}
            id="id-createOrder-select-partType"
            isDefaultValueUnique
            valueDefaultKey={part.idPartType}
            setValueCustom={setValue}
            label=''
            placeholder={getTranslateByKey('information.partTypes')}
            control={control}
            rulesCustom={{ required: false }}
            options={partTypeReducer.data}
            isLoading={partTypeReducer.isLoading}
            disabled={isDisabledPartTypeDrop}
            onChangeCustom={() => { }}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
          />
        )}
      </S.AreaTitlePart>

      <S.Quantity>
        {part.quantity}
      </S.Quantity>
      <KogCheckBoxControlled
        id={`id-searchOrder-checkbox-requote-select-${part.procurementSupplierItemGuid}`}
        nameCustom={nameField("isSelected")}
        control={control}
        label=''
      />
    </S.Container>
  )
}

export default RowItemRequoteOrdered